<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="mx-auto">
        <p class="primary--text font-weight-bold display-1 pl-3 pt-10 pl-sm-12">
          {{ formData.id ? "Editar" : "Nuevo" }} registro
        </p>
        <v-stepper
          v-model="stepperActiveTab"
          style="background-color:transparent; border: none; box-shadow: none"
        >
          <v-stepper-header style="box-shadow: none;" class="pl-sm-8 pr-sm-8">
            <v-stepper-step
              :complete="stepperActiveTab > 1"
              step="1"
              class="font-weight-medium"
              color="secondary"
            >
              <span>Ubicación</span>
            </v-stepper-step>

            <v-divider></v-divider>
            <v-stepper-step
              :complete="stepperActiveTab > 2"
              step="2"
              class="font-weight-medium"
              color="secondary"
            >
              <span>Buceo</span>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
              step="3"
              class="font-weight-medium"
              color="secondary"
            >
              <span>Especies</span>
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1" class="pa-3 pt-6">
              <div class="pl-sm-12 pr-sm-12">
                <EventFormLocation
                  :form-data.sync="formData"
                ></EventFormLocation>
                <div class="d-flex pa-4 pb-12">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#c0e2e6"
                    class="secondary--text font-weight-medium"
                    width="150"
                    rounded
                    @click="stepperActiveTab = 2"
                    large
                    >Continuar</v-btn
                  >
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-content step="2" style="position: relative" class="pa-0">
              <div class="pl-sm-12 pr-sm-12">
                <v-img
                  :src="castaneta"
                  height="400"
                  width="600"
                  contain
                  style="position: absolute; top: 400px; right: -250px; filter: opacity(20%)"
                ></v-img>

                <v-card class="mb-4" flat color="transparent">
                  <v-list-item>
                    <v-list-item-avatar tile>
                      <SvgIcon icon="cp-diver-1" fill="#0087af" height="75px" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        class="title font-weight-bold primary--text"
                        >Agrega el detalle de tu buceo</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <div>
                    <v-row>
                      <v-col cols="12" md="4">
                        <v-card outlined color="transparent">
                          <v-list color="transparent">
                            <v-list-item>
                              <v-list-item-avatar tile>
                                <SvgIcon
                                  icon="cp-event-date"
                                  fill="#0087af"
                                  height="35px"
                                />
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title
                                  class="body-1 font-weight-bold primary--text"
                                  >Fecha</v-list-item-title
                                >
                                <v-list-item-subtitle class="body-2"
                                  >Fecha en la que realizó el
                                  buceo</v-list-item-subtitle
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <div class="pa-4">
                            <v-card flat width="290" color="transparent">
                              <v-menu
                                ref="menuDatePicker"
                                v-model="menuDatePicker"
                                :close-on-content-click="false"
                                transition="scale-transition"
                              >
                                <template v-slot:activator="{ on }">
                                  <div>
                                    <v-text-field
                                      :value="computedDateFormattedDatefns"
                                      placeholder="Seleccionar..."
                                      outlined
                                      rounded
                                      max-width="500"
                                      hide-details
                                      v-on="on"
                                    ></v-text-field>
                                  </div>
                                </template>
                                <v-date-picker
                                  v-model="formData.eventDate"
                                  no-title
                                  :max="maxDate"
                                  required
                                  @input="menuDatePicker = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-card>
                          </div>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-card outlined color="transparent">
                          <v-list color="transparent">
                            <v-list-item>
                              <v-list-item-avatar tile>
                                <SvgIcon
                                  icon="cp-diver-2"
                                  fill="#0087af"
                                  height="35px"
                                />
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title
                                  class="body-1 font-weight-bold primary--text"
                                  >Tipo de buceo</v-list-item-title
                                >
                                <v-list-item-subtitle class="body-2"
                                  >Tipo de buceo
                                  desarrollado</v-list-item-subtitle
                                >
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <div class="pa-4 pt-2">
                            <v-chip-group
                              v-model="formData.samplingProtocol"
                              column
                              active-class="font-weight-bold"
                            >
                              <v-chip
                                :outlined="item !== formData.samplingProtocol"
                                large
                                v-for="(item, index) in typeList"
                                :key="index"
                                :value="item"
                                color="secondary"
                              >
                                <p
                                  style="width: 150px"
                                  class="ma-0 text-center"
                                >
                                  {{ item }}
                                </p>
                              </v-chip>
                            </v-chip-group>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-card max-width="900" color="transparent" flat>
                      <v-card outlined class="mt-4" color="transparent">
                        <v-list color="transparent">
                          <v-list-item>
                            <v-list-item-avatar tile>
                              <SvgIcon
                                icon="cp-event-temperature"
                                fill="#0087af"
                                height="35px"
                              />
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title
                                class="body-1 font-weight-bold primary--text"
                                >Temperatura</v-list-item-title
                              >
                              <v-list-item-subtitle class="body-2"
                                >Solo si registró temperatura con
                                computador</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>

                        <div class="d-flex ma-4 ml-4">
                          <v-text-field
                            label="Mínima"
                            v-model="formData.measurementValue.temperatureMin"
                            outlined
                            rounded
                            class="mr-3"
                            type="number"
                            suffix="Cº"
                          ></v-text-field>
                          <v-text-field
                            label="Máxima"
                            v-model="formData.measurementValue.temperatureMax"
                            outlined
                            rounded
                            class="ml-3"
                            type="number"
                            suffix="Cº"
                          ></v-text-field>
                        </div>
                      </v-card>

                      <v-card outlined class="mt-4" color="transparent">
                        <v-list-item>
                          <v-list-item-avatar tile>
                            <SvgIcon
                              icon="cp-event-depth"
                              fill="#0087af"
                              height="35px"
                            />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            <v-list-item-title
                              class="body-1 font-weight-bold primary--text"
                              >Profundidad</v-list-item-title
                            >
                            <v-list-item-subtitle class="body-2"
                              >Media, en la que desarrolló más parte del buceo y
                              máxima alcanzada</v-list-item-subtitle
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <div class="pa-4">
                          <v-row>
                            <v-col cols="12">
                              <v-card
                                outlined
                                class="pa-4 slider-container-custom"
                              >
                                <v-slider
                                  v-model="formData.verbatimDepth"
                                  thumb-label="always"
                                  ticks="always"
                                  tick-size="4"
                                  max="60"
                                  min="0"
                                  step="5"
                                  color="secondary"
                                  thumb-color="primary"
                                  track-color="#86a3b0"
                                  hide-details
                                >
                                  <template v-slot:thumb-label="{ value }">
                                    <span class="font-weight-bold">{{
                                      value
                                    }}</span>
                                  </template>
                                  <template v-slot:label>
                                    <div style="width: 70px">
                                      <span>Media</span>
                                    </div>
                                  </template>
                                  <template v-slot:append>
                                    <span
                                      class="caption font-weight-medium secondary--text"
                                      >m</span
                                    >
                                  </template>
                                </v-slider>
                              </v-card>
                            </v-col>
                            <v-col cols="12">
                              <v-card
                                outlined
                                class="pa-4 slider-container-custom"
                              >
                                <v-slider
                                  v-model="formData.maximumDepthInMeters"
                                  thumb-label="always"
                                  ticks="always"
                                  tick-size="4"
                                  max="60"
                                  min="0"
                                  step="5"
                                  color="secondary"
                                  thumb-color="primary"
                                  track-color="#86a3b0"
                                  hide-details
                                >
                                  <template v-slot:thumb-label="{ value }">
                                    <span class="font-weight-bold">{{
                                      value
                                    }}</span>
                                  </template>
                                  <template v-slot:label>
                                    <div style="width: 70px">
                                      <span>Máxima</span>
                                    </div>
                                  </template>
                                  <template v-slot:append>
                                    <span
                                      class="caption font-weight-medium secondary--text"
                                      >m</span
                                    >
                                  </template>
                                </v-slider>
                              </v-card>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card>

                      <v-row>
                        <v-col cols="12">
                          <v-card outlined color="transparent">
                            <v-list color="transparent">
                              <v-list-item>
                                <v-list-item-avatar tile>
                                  <SvgIcon
                                    icon="cp-event-duration"
                                    fill="#0087af"
                                    height="35px"
                                  />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="body-1 font-weight-bold primary--text"
                                    >Tiempo de fondo</v-list-item-title
                                  >
                                  <v-list-item-subtitle class="body-2">
                                    <span class="font-weight-medium"
                                      >Buceo repetitivo:</span
                                    >
                                    sume tiempos de fondo /
                                    <span class="font-weight-medium"
                                      >Apnea:</span
                                    >
                                    tiempo total del buceo
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                            <div class="pa-4">
                              <v-card
                                outlined
                                class="pa-4 slider-container-custom"
                              >
                                <v-slider
                                  ticks="always"
                                  tick-size="4"
                                  v-model="formData.samplingEffort"
                                  label="Total min."
                                  max="180"
                                  min="0"
                                  step="5"
                                  thumb-label="always"
                                  class="mr-3"
                                  color="secondary"
                                  thumb-color="primary"
                                  track-color="#86a3b0"
                                  hide-details
                                >
                                  <template v-slot:thumb-label="{ value }">
                                    <span class="font-weight-bold">{{
                                      value
                                    }}</span>
                                  </template>
                                </v-slider>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                        <v-col cols="12">
                          <v-card outlined color="transparent">
                            <v-list color="transparent">
                              <v-list-item>
                                <v-list-item-avatar tile>
                                  <SvgIcon
                                    icon="cp-event-visibility"
                                    fill="#0087af"
                                    height="35px"
                                  />
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <v-list-item-title
                                    class="body-1 font-weight-bold primary--text"
                                    >Visibilidad</v-list-item-title
                                  >
                                  <v-list-item-subtitle class="body-2"
                                    >Visibilidad media estimada o
                                    medida</v-list-item-subtitle
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                            <div class="pa-4">
                              <v-card
                                outlined
                                class="pa-4 slider-container-custom"
                              >
                                <v-slider
                                  class="ml-3"
                                  label="Media"
                                  ticks="always"
                                  tick-size="4"
                                  v-model="
                                    formData.dynamicProperties.visibilityMeters
                                  "
                                  thumb-label="always"
                                  max="20"
                                  min="0"
                                  step="1"
                                  color="secondary"
                                  thumb-color="primary"
                                  track-color="#86a3b0"
                                  hide-details
                                >
                                  <template v-slot:thumb-label="{ value }">
                                    <span class="font-weight-bold">{{
                                      value
                                    }}</span>
                                  </template>
                                  <template v-slot:append>
                                    <span
                                      class="caption font-weight-medium secondary--text"
                                      >m</span
                                    >
                                  </template>
                                </v-slider>
                              </v-card>
                            </div>
                          </v-card>
                        </v-col>
                      </v-row>

                      <v-card outlined class="mt-2" color="transparent">
                        <v-list color="transparent">
                          <v-list-item>
                            <v-list-item-avatar tile>
                              <SvgIcon
                                icon="cp-event-current"
                                fill="#0087af"
                                height="35px"
                              />
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title
                                class="body-1 font-weight-bold primary--text"
                                >Corriente</v-list-item-title
                              >
                              <v-list-item-subtitle
                                >Basado en su percepción de la
                                corriente</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <div class="pa-4 pt-0">
                          <v-chip-group
                            v-model="formData.current"
                            column
                            active-class="font-weight-bold"
                          >
                            <v-chip
                              large
                              v-for="(item, index) in corrienteList"
                              :key="index"
                              :value="item"
                              :outlined="item !== formData.current"
                              color="secondary"
                            >
                              <p
                                class="text-center ma-0"
                                style="min-width:100px;"
                              >
                                {{ item }}
                              </p>
                            </v-chip>
                          </v-chip-group>
                        </div>
                      </v-card>

                      <v-card outlined class="mt-4" color="transparent">
                        <v-list color="transparent">
                          <v-list-item>
                            <v-list-item-avatar tile>
                              <SvgIcon
                                icon="cp-event-habitat"
                                fill="#0087af"
                                height="35px"
                              />
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title
                                class="body-1 font-weight-bold primary--text"
                                >Hábitat</v-list-item-title
                              >
                              <v-list-item-subtitle class="body-2"
                                >Hábitat/sustrato que se observó la mayor parte
                                del buceo</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <div class="pa-4 pt-0 d-flex flex-wrap justify-center">
                          <v-chip-group
                            v-model="formData.habitat"
                            column
                            multiple
                            active-class="font-weight-bold"
                          >
                            <v-tooltip
                              top
                              v-for="(item, index) in habitatList"
                              :key="index"
                              color="primary"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                  v-bind="attrs"
                                  v-on="on"
                                  :outlined="
                                    !(formData.habitat || []).includes(
                                      item.name
                                    )
                                  "
                                  large
                                  :value="item.name"
                                  color="secondary"
                                >
                                  <p
                                    style="width: 165px"
                                    class="ma-0 text-center"
                                  >
                                    {{ item.name }}
                                  </p>
                                </v-chip>
                              </template>
                              <span>{{ item.description }}</span>
                            </v-tooltip>
                          </v-chip-group>
                        </div>
                      </v-card>
                    </v-card>
                  </div>
                </v-card>

                <div class="d-flex pa-4">
                  <v-btn
                    text
                    @click="stepperActiveTab = 1"
                    color="primary"
                    tile
                    class="underline-decoration-custom pl-0 pr-0"
                  >
                    <v-icon left>mdi-chevron-left</v-icon>
                    <span>Volver</span>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#c0e2e6"
                    class="secondary--text font-weight-medium"
                    width="150"
                    large
                    rounded
                    @click="stepperActiveTab = 3"
                    >Continuar</v-btn
                  >
                </div>
              </div>
            </v-stepper-content>

            <v-stepper-content step="3" class="pa-3 pl-sm-12 pr-sm-12">
              <OccurrenceForm
                class="mb-4"
                :list.sync="formData.occurrenceList"
                v-if="stepperActiveTab == 3"
              ></OccurrenceForm>

              <div class="d-flex pa-4">
                <v-btn
                  text
                  color="primary"
                  @click="stepperActiveTab = 2"
                  tile
                  class="underline-decoration-custom pl-0 pr-0"
                >
                  <v-icon left>mdi-chevron-left</v-icon>
                  <span>Volver</span>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="#c0e2e6"
                  class="secondary--text font-weight-medium"
                  width="150"
                  rounded
                  @click="save"
                  large
                  :loading="dialogLoading"
                  >Guardar</v-btn
                >
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>

    <v-img :src="IMG_0499" height="200" full-width position="0 40%"></v-img>

    <v-dialog v-model="dialogLoading" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="loading" />
          <p class="font-weight-medium text-center title">Guardando...</p>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogStatusError" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">
            Lo sentimos, ha ocurrido un error
          </p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogStatusError = false"
            color="primary"
            class="container"
            >Aceptar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbarSuccess" color="success">Buena</v-snackbar>
  </div>
</template>

<script>
import EventFormLocation from "./EventFormLocation";
import OccurrenceForm from "../Occurrence/OccurrenceForm";
import SvgIcon from "../SvgIcon";
import { format, parseISO, formatISO, startOfDay, addMinutes } from "date-fns";
import { es } from "date-fns/esm/locale";

export default {
  components: { EventFormLocation, OccurrenceForm, SvgIcon },
  data: () => ({
    castaneta: require("@/assets/nuevo_registro/castaneta.png"),
    IMG_0499: require("@/assets/landing/IMG_0499.jpg"),
    stepperActiveTab: 1,
    menuDatePicker: false,
    dialogLoading: false,
    snackbarSuccess: false,
    maxDate: formatISO(new Date(), { representation: "date" }),
    formData: {
      eventDate: formatISO(new Date(), { representation: "date" }),
      location: {},
      measurementValue: {},
      dynamicProperties: {}
    },
    dialogStatusSuccess: false,
    dialogStatusError: false,
    typeList: ["Autónomo deportivo", "Semi Autónomo", "Apnea", "Técnico"],
    corrienteList: ["Ninguna", "Suave", "Fuerte"],
    visibilityList: ["Menos de un metro"],
    habitatList: [
      {
        name: "Bolones / Roca",
        description:
          "Zona con dominancia de rocas de mediano a gran tamaño sobrepuestas en el fondo marino"
      },
      {
        name: "Fondo blando",
        description: "Fondo marino dominado por material arenoso, fango o limo"
      },
      {
        name: "Pared rocosa",
        description: "Pared vertical con caída de mas de 7 metros de altura"
      },
      {
        name: "Acantilado",
        description:
          "Zona de buceo contigua a acantilados, con una gran pendiente o gradiente de profundidad en una corta distancia"
      },
      {
        name: "Islote/bajerío",
        description:
          "Gran roca o grupo de rocas con empinadas laderas que se levanta de las aguas profundas hacia la superficie"
      },
      {
        name: "Pradera de macroalgas",
        description: "Bosques o praderas de algas de gran tamaño"
      },
      {
        name: "Océano abierto",
        description:
          "Buceo desarrollado en un área de gran profundidad, donde no es posible reconocer el fondo "
      },
      {
        name: "Pasto marino",
        description: "Zonas con presencia de pasto marino sobre fondo blando"
      },
      {
        name: "Estructura artificial",
        description:
          "Estructura construida por el hombre como muelles, naufragios, rompeolas o cualquier estructura no natural"
      }
    ]
  }),
  methods: {
    async save() {
      try {
        this.dialogLoading = true;

        if (this.formData.id) {
          await this.$http.patch("event/" + this.formData.id, {
            ...this.formData,
            organismList: (this.formData.occurrenceList || []).map(
              ({ organism }) => organism.id
            ),
            attachementList: undefined,
            recordedBy: undefined,
            occurrenceList: undefined,
            eventDate:
              new Date(this.formData.eventDate).getTime() +
              new Date(this.formData.eventDate).getTimezoneOffset() * 60 * 1000
          });
        } else {
          let { data: eventCreated } = await this.$http.post("event", {
            ...this.formData,
            organismList: (this.formData.occurrenceList || []).map(
              ({ organism }) => organism.id
            ),
            occurrenceList: undefined,
            eventDate:
              new Date(this.formData.eventDate).getTime() +
              new Date(this.formData.eventDate).getTimezoneOffset() * 60 * 1000,
            recordedBy: this.practitionerLogged.id
          });
          this.formData.id = eventCreated.id;
        }

        for (let occurrence of this.formData.occurrenceList || []) {
          if (occurrence.id) {
            await this.$http.patch("occurrence/" + occurrence.id, {
              attachementList: undefined,
              individualCount: occurrence.individualCount,
              doubt: occurrence.doubt,
              deleted: occurrence.deleted,
              organism: (occurrence.organism || {}).id
            });
          } else {
            let { data: occurrenceCreated } = await this.$http.post(
              "occurrence",
              {
                event: this.formData.id,
                attachementList: undefined,
                individualCount: occurrence.individualCount,
                doubt: occurrence.doubt,
                organism: (occurrence.organism || {}).id
              }
            );
            occurrence.id = occurrenceCreated.id;
          }

          //Function for weight abundance for a organism
          let weightSum = 0;
          if (occurrence.individualCount === "Único (1)") {
            weightSum = 1;
          } else if (occurrence.individualCount === "Poco abundante (2-10)") {
            weightSum = 3;
          } else if (occurrence.individualCount === "Abundante (11-50)") {
            weightSum = 5;
          } else if (occurrence.individualCount === "Muy abundante (50+)") {
            weightSum = 7;
          }

          await this.$http.patch("organism/" + occurrence.organism.id, {
            weightAbundance: occurrence.organism.weightAbundance + weightSum
          });

          for (let attachement of occurrence.attachementList || []) {
            if (attachement.id) {
              await this.$http.patch("attachement/" + attachement.id, {
                deleted: attachement.deleted
              });
            } else {
              await this.$http.post("attachement", {
                archive: (attachement.archive || {}).id,
                occurrence: occurrence.id,
                organism: (occurrence.organism || {}).id,
                event: this.formData.id
              });
            }
          }
        }
        this.snackbarSuccess = true;
        this.$router.push("/costa-pez/buceos/" + this.formData.id);
      } catch (err) {
        console.log(err);
        this.dialogStatusError = true;
      }
      this.dialogLoading = false;
    },
    async getEvent() {
      try {
        let { data: event } = await this.$http.get(
          "event/" + this.$route.params.id
        );
        let [day, month, year] = event.eventDateLegible.split("/");
        this.formData = {
          ...event,
          eventDate: formatISO(new Date(year + "/" + month + "/" + day), {
            representation: "date"
          })
        };

        if (!event.recordedBy.id == this.practitionerLogged.id) {
          this.$route.to("/costa-pez/mis-buceos");
        }
      } catch (err) {
        console.log(err);
      }
    }
  },
  computed: {
    practitionerLogged() {
      return this.$store.getters["authPractitioner/getPractitioner"];
    },
    computedDateFormattedDatefns() {
      return this.formData.eventDate
        ? format(
            addMinutes(
              new Date(this.formData.eventDate),
              new Date(this.formData.eventDate).getTimezoneOffset()
            ),
            "dd/MM/yyyy"
          )
        : "";
    }
  },
  async mounted() {
    if (this.$route.params.id) {
      this.getEvent();
    }
  }
};
</script>

<style>
.slider-container-custom {
  background-color: transparent !important;
  border-radius: 50px !important;
  border: 1px solid !important;
  border-color: var(--v-secondary-base) !important;
}

.underline-decoration-custom {
  border-bottom: 2px solid;
  border-color: var(--v-primary-base);
}

.v-slider__tick {
  border-radius: 50% !important;
}
.v-stepper__step--inactive .v-stepper__step__step {
  background-color: transparent !important;
  border: 2px solid;
  border-color: var(--v-secondary-lighten3);
  color: var(--v-secondary-lighten3) !important;
}

.v-stepper__step--inactive .v-stepper__label {
  color: var(--v-secondary-lighten3) !important;
}

.v-stepper__step--complete .v-stepper__label {
  color: var(--v-secondary-base) !important;
}
.v-stepper__step--active .v-stepper__label {
  color: var(--v-secondary-base) !important;
}
</style>
